<template>
  <div class="footer">这是底部</div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background-color: #616161;
}
</style>
